import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select, { Creatable } from 'react-select';
import _ from 'lodash';

import { fetchPerson } from '../../store/modules/person';
import { fetchStaff } from '../../store/modules/staff';

import { GravatarOption } from './GravatarOption';
import { GravatarValue } from './GravatarValue';

const mapActionCreators = {
  fetchPerson,
  fetchStaff,
};

const mapStateToProps = state => ({
  personsFetching: state.person.fetching,
  persons: state.person.persons,
  staffs: state.staff.staffs,
});

class PeoplePicker extends React.Component {
  constructor(props) {
    super(props);

    let value = [];

    if (typeof props.value !== 'undefined') {
      value = props.value;
    }

    this.state = {
      value,
    };

    props.fetchStaff();
    props.fetchPerson();
  }

  componentWillReceiveProps(nextProps) {
    // // console.log('receiving...', JSON.stringify(nextProps.value));

    if (this.state.value === null || this.state.value.length === 0) {
      if (typeof nextProps.value !== 'undefined') {
        this.setState({ value: nextProps.value });
      }
    }

    if (nextProps.value === '--clearme--') {
      if (nextProps.default !== null) {
        // if (Array.isArray(nextProps.default)) {
        //   this.setValue(nextProps.default);
        // } else {
        //   this.setValue([nextProps.default]);
        // }
        this.setState({ value: nextProps.default });
        this.props.onChange({
          target: {
            name: this.props.name,
            value: nextProps.default,
          },
        });
      } else {
        this.setValue([]);
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      Object.keys(nextProps.persons).length +
      Object.keys(nextProps.staffs).length
    );
  }

  setValue = value => {
    // // console.log('selected', value);

    this.setState({ value });

    if (value && typeof value.length !== 'undefined') {
      const vals = value.map(val => val.value);

      this.props.onChange({
        target: {
          name: this.props.name,
          value: vals,
          rawValue: value,
        },
      });
    } else {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: value.value,
          rawValue: value,
        },
      });
    }
  };

  render() {
    const props = _.cloneDeep(this.props);

    const placeholder = <span>Tippen um zu suchen..</span>;

    let allData = _.cloneDeep(this.props.staffs);

    if (props.type === 'users') {
      allData = _.cloneDeep(
        _.filter(this.props.staffs, item => item.user_id !== null),
      );
    } else if (props.type === 'persons') {
      allData = _.cloneDeep(this.props.persons);
    } else if (props.type === 'all') {
      allData = {};

      // need different prefixes on the key as it might be the same on persons and staffs
      _.forOwn(this.props.persons, data => {
        allData[`person_${data.id}`] = Object.assign({}, data);
      });

      _.forOwn(this.props.staffs, data => {
        allData[`staff_${data.id}`] = Object.assign({}, data);
      });
    }

    const multi = typeof props.multi === 'undefined' ? false : props.multi;

    const selectData = [];
    _.forOwn(allData, data => {
      // // console.log(data)
      // create new object that will be handled by griddle
      let type = '';
      let value = '';

      if (
        (typeof data.deleted_at === 'undefined' || data.deleted_at === null) &&
        typeof data.name !== 'undefined' &&
        data.name !== null
      ) {
        if (this.props.type === 'all') {
          if (data.type === 'person') {
            type = ' (K)';
            value = `person[${data.id}]`;
          } else {
            type = ' (M)';
            value = `staff[${data.id}]`;
          }
        } else {
          value = data.id;
        }

        if (props.type !== 'user' || data.user_id !== null) {
          selectData.push({
            value,
            title: data.name,
            label: `${data.name} ${type}`,
            avatar: data.avatar,
            type: data.type,
            userId: data.user_id,
          });
        }
      }
    });

    if (props.type === 'staff' || props.type === 'users') {
      return (
        <div className="section">
          <Select
            onChange={this.setValue}
            optionComponent={GravatarOption}
            options={selectData}
            placeholder={placeholder}
            valueComponent={GravatarValue}
            multi={multi}
            value={this.state.value}
            clearable={
              typeof props.clearable !== 'undefined' ? props.clearable : true
            }
          />
        </div>
      );
    }

    return (
      <div className="section">
        <Creatable
          onChange={this.setValue}
          optionComponent={GravatarOption}
          options={selectData}
          placeholder={placeholder}
          valueComponent={GravatarValue}
          multi={multi}
          value={this.state.value}
          promptTextCreator={label => `Neuen Kontakt erstellen: ${label}`}
          clearable={
            typeof props.clearable !== 'undefined' ? props.clearable : true
          }
        />
      </div>
    );
  }
}

PeoplePicker.propTypes = {
  // visual only data
  hint: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  label: PropTypes.string, // eslint-disable-line react/no-unused-prop-types

  // configuration of the picker
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  clearable: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types

  // functions
  onChange: PropTypes.func.isRequired,
  fetchStaff: PropTypes.func.isRequired,
  fetchPerson: PropTypes.func.isRequired,

  // data resources
  persons: PropTypes.object,
  staffs: PropTypes.object,
  personsFetching: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types

  // selectors from forms
  value: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  // only used if an empty value is passed
  default: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
};

PeoplePicker.defaultProps = {
  default: null,
};

export default connect(mapStateToProps, mapActionCreators)(PeoplePicker);



// WEBPACK FOOTER //
// ./src/components/PeoplePicker/PeoplePicker.js